import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export const STATUS_CHIP_TONES = {
  green: { background: '#e3f4e8', color: '#1f7a3f' },
  blue: { background: '#e8f1fd', color: '#245fae' },
  amber: { background: '#fff3df', color: '#a75a0a' },
  red: { background: '#fde8e8', color: '#b42318' },
  grey: { background: '#eef1f5', color: '#475569' },
};

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 24,
    boxSizing: 'border-box',
    padding: '4px 10px',
    borderRadius: 6,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
  },
});

export const toneForStatus = (status) => {
  const value = String(status || '').trim().toLowerCase().replace(/[\s-]+/g, '_');

  if (['active', 'approved', 'complete', 'completed', 'enabled', 'published', 'success', 'succeeded'].includes(value)) return 'green';
  if (['declined', 'deleted', 'error', 'expired', 'failed', 'overdue', 'rejected'].includes(value)) return 'red';
  if (['draft', 'pending', 'scheduled', 'waiting'].includes(value)) return 'amber';
  if (['in_progress', 'open', 'processing', 'running'].includes(value)) return 'blue';
  return 'grey';
};

const StatusChip = ({ tone = 'grey', children, className = '', style }) => {
  const classes = useStyles();
  const palette = STATUS_CHIP_TONES[tone] || STATUS_CHIP_TONES.grey;

  return (
    <span
      className={[classes.root, className].filter(Boolean).join(' ')}
      style={{ backgroundColor: palette.background, color: palette.color, ...style }}
    >
      {children}
    </span>
  );
};

export default StatusChip;
